module.exports = __webpack_public_path__ + "img/music_014.8c0d5e32.png";